import React from 'react';
import { observer } from 'mobx-react';

import { Form } from 'libs/forms/index';
import { Modal } from 'apps/modals/views/modal';
import { ModalTitle } from 'legacyComponents/styled/lib';
import { modalStore } from 'apps/modals/app';
import { Trans } from 'react-i18next';

@observer
export class AddAssigneesForm extends Modal {
  render() {
    const { issueTrackerManager } = modalStore.props;
    const { issuePage: issue } = issueTrackerManager;
    const { addAssigneesForm } = issue;
    const {
      conf: { formTitle },
    } = addAssigneesForm;
    return (
      <>
        <ModalTitle level={2}>
          <Trans>{`${formTitle} to Task #${issue.number}`}</Trans>
        </ModalTitle>
        <Form
          formStore={addAssigneesForm}
          formTitle=''
          buttonHandler={issueTrackerManager.AddAssignees}
          noBorder={true}
          responsive
        />
      </>
    );
  }
}
